<template>
  <div id="app">
    <loading :active.sync="loading"
             :is-full-page="fullPage">
      <div class="text-center">
        <div>
          <img alt="logo" src="./assets/img/logo-new.svg" class="logo">
        </div>
        <Loader />
      </div>
    </loading>
    <router-view v-if="!loading"/>
    <Modal v-if="!loading && linkRequest && linkRequest.show" :hideclose="true">
      <div slot="header" class="content-block-title mb-0 mt-0 mr-2 w-75 text-center">{{ $lang.messages.account.linked_account_modal_title }}</div>
      <div slot="content">
        <LinkRequestDialog />
      </div>
    </Modal>
    <IconsSvg/>
  </div>
</template>


<script>
import Loading from 'vue-loading-overlay';
import Loader from "./components/Loader";
import Modal from "./components/common/Modal";
import LinkRequestDialog from "@/components/LinkRequestDialog";
import 'vue-loading-overlay/dist/vue-loading.css';
import firebase from "firebase/app";
import { connectToExtension, checkDBState, loginWithToken } from './helpers/utils';
import { addActiveCampaignTag } from './helpers/api';
import CONST from "./helpers/constants";
import store from "./store/store";
import saveSetting from "@/components/mixins/saveSetting";
import IconsSvg from "@/components/common/IconsSvg";

const {LINKED_ACCOUNT_STATUSES} = CONST;
import { getSubscriptions } from './helpers/api'
import {mapGetters} from "vuex";

const accessMap = {
  anonymous: {
    allowedRoutes: ['/login', '/removed', '/', '/addDevice', '/premium'],
    redirectUrl: '/login'
  },
  premium: {
    allowedRoutes: ['*'],
    redirectUrl: '/dashboard'
  },
  remote: {
    allowedRoutes: ['/login', '/removed', '/premium', '/addDevice'],
    redirectUrl: '/premium'
  },
  regular: {
    allowedRoutes: ['/dashboard', '/popup', '/login', '/plug', '/removed', '/account', '/request',
      '/profile', '/kid', '/locked', '/removed', '/freeDashboard', '/',
      '/profile/defaultProfileSettings', '/links', '/help', '/recover', '/premium'],
    redirectUrl: '/plug'
  }
}

export default {
  name: "App",
  mixins: [saveSetting],
  data() {
    return {
      isLoading: true,
      fullPage: true,
      isAndroid: window.Android,
      testPayment: localStorage.getItem('stripeTest'),
    }
  },
  components: {
    IconsSvg,
    Loading,
    Loader,
    Modal,
    LinkRequestDialog,
  },
  methods: {
    async getSubs() {
      if (this.$store.state.accountData && this.$store.state.accountData.customer) {
        const subs = await getSubscriptions(this.$store.state.accountData.customer.id, this.testPayment);
        if (subs.error) {
          console.log(subs.error.message);
        } else {
          const subscriptionStatus = subs.subscriptions ? subs.subscriptions.data[0].status : null;
          this.saveAccountSettings(
              {
                isPremium: subscriptionStatus === 'active' || subscriptionStatus === 'trialing',
              }
          )
        }
      }
    },
     checkUser() {
      firebase.auth().onAuthStateChanged(async (user) => {
        console.log('uid ', user && user.uid);
        if (user) {
          /***********************/
          const mainUid = await firebase.auth()
              .currentUser
              .getIdTokenResult()
              .then((idTokenResult) => {
                const { linkedUid } = idTokenResult.claims;
                return linkedUid;
              })
              .catch((error) => {
                console.log(error);
              });
          /***********************/
          const firebaseDatabaseID = mainUid ? mainUid : user.uid;
          localStorage.setItem('firebaseUserId', user.uid);
          const { token } = this.$router.currentRoute.query;

          if (token && user.uid !== token) {
            await firebase.auth().signOut();
            return;
          }
          this.$store.commit('showLoginFormLoader', true);

          await checkDBState(firebaseDatabaseID);
          const deviceID = await connectToExtension(firebaseDatabaseID, false);
          this.$store.commit('setDeviceID', deviceID);
          this.$store.commit('setIsRemote', !deviceID);
          this.$store.commit('setUserID',
              {
                uid: user.uid,
                email: user.email,
                displayName: user.displayName,
                isLinked: !!mainUid,
                mainUid,
              });

          await this.$store.dispatch('bindLinkedData');
          this.$store.dispatch('bindAccountData', {
            uid: firebaseDatabaseID,
          }).then(() => {
            const settings = this.$store.state.accountData;
            const isPremium = settings.isPremium;
            const isRemoteAndNotPremium = !deviceID && !isPremium;
            const hasNameAndPass = settings.isRegistered;
            const currentPath = this.$route.path;
            this.getSubs();
            if (isRemoteAndNotPremium) {
              console.log(currentPath);
              if (currentPath !== '/login' && currentPath !== '/addDevice' && currentPath !== '/premium' && !hasNameAndPass) {
                this.$router.push('/login');
              } else if (currentPath !== '/premium' && currentPath !== '/removed' && currentPath !== '/addDevice' && hasNameAndPass) {
                this.$router.push('/premium');
              }

            } else if (deviceID && this.$route.path === '/login' && hasNameAndPass) { // log in flow
              if (this.isAndroid) {
                window.Android.onRegistrationEnd();
              } else {
                this.$router.push(isPremium ? '/dashboard' : '/freeDashboard');
              }
            } else if (this.$route.path === '/login' && isPremium) {
              this.$router.push('/dashboard');
            } else if (this.$route.path === '/locked' && this.$store.state.accountData.devices[deviceID].currentProfileID) {
              this.$router.push('/kid');
            } else if (this.$route.path === '/freeDashboard' && isPremium && !deviceID) {
              this.$router.push('/dashboard');
            }

            this.isLoading = false;

            const role = store.getters.getUserRole;
            const userAccess = accessMap[role];

            if (!userAccess.allowedRoutes.includes(this.$route.path) &&
                userAccess.allowedRoutes[0] !== '*' &&
                userAccess.redirectUrl !== this.$route.path) {
              console.log('redirected', role, this.$route.path);
              this.$router.push(userAccess.redirectUrl)
            }

            if (deviceID && (!settings.androidInstall && this.isAndroid || !settings.extensionInstall && !this.isAndroid)) {
              const tag = this.isAndroid ? CONST.ACTIVE_CAMPAIGN.TAGS.APP_INSTALL: CONST.ACTIVE_CAMPAIGN.TAGS.EXTENSION_INSTALL;
              addActiveCampaignTag({
                email: user.email,
                tag: tag,
              }).then(() => {
                const updatedActiveCampaignList = {};
                updatedActiveCampaignList[this.isAndroid ? 'androidInstall' : 'extensionInstall'] = true;
                this.saveAccountSettings(updatedActiveCampaignList)
              });
            }
            //this.$store.commit('showLoginFormLoader', false);
          })
        } else  {
          this.$store.commit('showLoginFormLoader', false);
          const { token } = this.$router.currentRoute.query;

          if (token) {
            loginWithToken(token);
          } else {
            if (this.$route.path !== '/login' && this.$route.path !== '/') {
              console.log(this.$route.path);
              this.$router.push('/login');
            }
            this.$store.commit('setUserID', {})
            this.isLoading = false;
            if (window.Android) {
              window.Android.userSignOut();
            } else {
              await connectToExtension(null);
            }
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      linkRequest: 'linkRequest'
    }),
    deviceCount() {
      return this.$store.getters.deviceCount;
    },
    user() {
      return this.$store.state.user;
    },
    fbUiShowing(){
      return this.$store.state.fbUiShowing;
    },
    loading(){
      return this.isLoading
    }
  },
  watch: {
    linkRequest: function (newVal, oldVal){
      if(oldVal && oldVal.status === LINKED_ACCOUNT_STATUSES.APPROVED && newVal === false){
        window.location.reload()
      }
    }
  },
  created() {
    this.checkUser()
  },
};
</script>

<style lang="scss">

.vld-overlay .vld-background {
  opacity: 1;
}
</style>